import { React, useEffect, useRef, useState } from "react";
import Email_Icon from "../assets/images/Email_Icon.png";
import Password_Icon from "../assets/images/Password_Icon.png";
import { Icon } from "@iconify/react";
import google from "../assets/images/google.png";
import facebook from "../assets/images/facebook.png";
import twitter from "../assets/images/twitter.png";
import logo from "../assets/images/user_opt_logo.png";
import check_ from "../assets/images/check.png";
import video from "../assets/vedio/Opt_vedio.mp4";
import * as Yup from "yup";
import uncheck from "../assets/images/uncheck.png";
import { toast } from "react-toastify";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import VerifyEmail from "../components/VerifyEmail";
import UserVerifyEmail from "./userVerifyEmail";

function UserSignIn() {
  const navigate = useNavigate();
  const [showpassword, setshowpassword] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openRecoveryModal, setOpenRecoveryModal] = useState(false);
  const [openResetPasswordModal, setOpenResetPasswordModal] = useState(false);
  const [check, setcheck] = useState(false);
  const [errors, setErrors] = useState({});
  const [userCreds, setUserCreds] = useState({
    email: "",
    password: "",
  });
  const emailref = useRef(null);
  const passwordref = useRef(null);


  const token = secureLocalStorage.getItem("token")
  const role = secureLocalStorage.getItem("role")
  const id = secureLocalStorage.getItem("id")


  useEffect(() => {
    if(token && role == "user"){
      navigate(`/account/${id}`)
    }else{
      navigate("/signin")
    }
  } , [])


  const handleClick = async () => {
    // Validate user query data
    const validationErrors = await validateusercreds(userCreds);
    // If there are validation errors, set the errors state
    if (validationErrors) {
      setErrors(validationErrors);
      if (validationErrors.email) {
        emailref.current.focus();
      } else if (validationErrors.password) {
        passwordref.current.focus();
      }
    } else {
      setErrors("");
      handleApi();
    }
  };

  const handleApi = () => {
    const apiKey = process.env.REACT_APP_API;
    axios
      .post(`${process.env.REACT_APP_API}/login`, {
        email: userCreds.email,
        password: userCreds.password,
      })
      .then((response) => {
        toast.success("Login Successful");
        localStorage.clear();
        console.log(response.data.token);
        secureLocalStorage.setItem("token", response.data.token);
        secureLocalStorage.setItem("id", response.data.id);
        secureLocalStorage.setItem("role", response.data.role);
        if (response.data.role === "user") {
          navigate(`/userDashboard/${response.data.id}`);
        } else {
          navigate(`/dashboard/${response.data.id}`);
        }
      })
      .catch((error) => {
        console.log("warning", error);

        if (error.response.data.Warning) {
          toast.error(error.response.data.Warning);
        } else {
          toast.error("Invalid email or password");
        }
      });
  };

  const usercredSchema = Yup.object().shape({
    email: Yup.string().required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  const validateusercreds = async (data) => {
    try {
      // Validate user query data against the schema
      await usercredSchema.validate(data, { abortEarly: false });

      // If validation succeeds, return null
      return null;
    } catch (error) {
      // If validation fails, return an object containing error messages
      return error.inner.reduce((errors, err) => {
        return {
          ...errors,
          [err.path]: err.message,
        };
      }, {});
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleClick();
    }
  };

  return (
    <div className="font-userFont">
      <div className=" sign_in flex  justify-center items-center md:items-stretch lg:items-start h-screen">
        <div className="sign_up_left hidden md:block lg:w-3/5 relative h-screen xl:w-[68%]   ">
          <video
            autoPlay
            muted
            loop
            width="100%"
            height="500"
            playsInline
            // controls
            className=" h-screen   w-full  object-cover"
          >
            <source src={video} type="video/mp4" className=" h-fit" />
          </video>{" "}
          <div className="!h-screen absolute top-0 left-0  w-full bg-black opacity-50"></div>
        </div>
        <div className="!h-screen flex  items-center justify-center flex-col sign_up_right w-full md:w-[32%]   bg-white  pt-7 lg:pt-6 2xl:pt-[60px] px-5 lg:px-7  2xl:px-14 pb-2  ">
          <div className=" w-[200px] md:w-[250px] xl:w-[260px] 2xl:w-[320px] md:h-[60px] 2xl:h-[92px] flex mb-[15px] md:mb-[25px] xl:mb-[30px]  2xl:mb-[50px] justify-center it ">
            <img src={logo} alt="" className="w-full h-full cursor-pointer" onClick={() => navigate("/")} />
          </div>

          <form>
            <div className="form-container flex flex-col gap-3 md:gap-4 2xl:gap-8">
              <h2 className="text-center text-2xl lg:text-4xl 2xl:text-5xl pb-4 2xl:pb-5 font-semibold ">
                Sign In
              </h2>
              <div className="input items-center flex gap-3 border-2 !border-[#E3D0A8] rounded-xl p-2 md:p-3  2xl:p-[22px] ">
                <img
                  className="w-4 h-4 md:h-auto md:w-auto"
                  src={Email_Icon}
                  color="#E3D0A8"
                  alt=""
                />
                <input
                  className="!border-none  !focus:outline-none border p-0  focus:ring-0 w-full placeholder:text-[#E3D0A8]  text-2xl placeholder:text-2xl "
                  type="text"
                  ref={emailref}
                  placeholder="Email or Username"
                  value={userCreds.email}
                  onChange={(e) => {
                    setUserCreds({
                      ...userCreds,
                      email: e.target.value.toLowerCase(),
                    });
                    setErrors({ ...errors, email: "" });
                  }}
                  onKeyDown={(e) => {
                    handleKeyDown(e);
                  }}
                />
              </div>
              {errors.email && (
                <p className=" text-[#ff6839]  text-sm  ">{errors.email}</p>
              )}

              <div className="">
                <div className="input items-center flex gap-3 border-2 !border-[#E3D0A8] rounded- md:rounded-xl p-2 md:p-3  2xl:p-[22px] ">
                  <img
                    className="w-4 h-4 md:h-auto md:w-auto"
                    src={Password_Icon}
                    color="#E3D0A8"
                    alt=""
                  />
                  <input
                    className="!border-none  focus:outline-none text-2xl  border  p-0 focus:ring-0 w-full placeholder:text-[#E3D0A8]  placeholder:text-2xl "
                    type={showpassword ? "text" : "password"}
                    placeholder="Password"
                    value={userCreds.password}
                    ref={passwordref}
                    onChange={(e) => {
                      setUserCreds({ ...userCreds, password: e.target.value });
                      setErrors({ ...errors, password: "" });
                    }}
                    onKeyDown={(e) => {
                      handleKeyDown(e);
                    }}
                  />
                  {showpassword ? (
                    <>
                      <Icon
                        icon="clarity:eye-show-line"
                        color="#E3D0A8"
                        width="25"
                        height="25"
                        onClick={() => {
                          setshowpassword(false);
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <Icon
                        icon="clarity:eye-hide-line"
                        color="#E3D0A8"
                        width="25"
                        height="25"
                        onClick={() => {
                          setshowpassword(true);
                        }}
                      />
                    </>
                  )}
                </div>
                {errors.password && (
                  <p className=" text-[#ff6839]  text-sm mt-3">
                    {errors.password}
                  </p>
                )}
                <div className="flex justify-between items-center">
                  <div
                    className=" mt-[18px]  gap-3  cursor-pointer "
                    onClick={() => {
                      setcheck(!check);
                    }}
                  >
                    {/* <div className="flex items-center gap-3">
                      <input
                    type="checkbox"
                    className="focus:ring-0 accent-[#50d71e]"
                  />
                      {check ? (
                        <>
                          <div className=" w-6 h-6">
                            <img
                              src={check_}
                              alt=""
                              className="w-full h-full"
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <div className=" w-6 h-6">
                            <img
                              src={uncheck}
                              alt=""
                              className="w-full h-full"
                            />
                          </div>
                        </>
                      )}
                      <span className="text-[#E3D0A8] 2xl:text-[22px]">
                        Remember me
                      </span>
                    </div> */}
                  </div>

                  <div className="  mt-3 cursor-pointer text-[#E3D0A8]  2xl:text-[22px] ">
                      <h2 onClick={() => setOpenModal(true)}>
                        Forgot Password?
                      </h2>
                  </div>
                </div>
              </div>

              <a>
                <div
                  className={`bg-[#E3D0A8] text-center px-4 py-2.5 text-white hover:bg-white hover:!text-[#E3D0A8] ease-in-out duration-300 hover:!border hover:!border-[#E3D0A8] `}
                  onClick={handleClick}
                >
                  Sign In
                </div>
              </a>

              <p className="text-sm 2xl:text-xl text-center mt-4 Campton-light">
                Don’t have an account?
                <Link to="/signup">
                  <span className="text-[#E3D0A8] ps-3">Sign Up</span>
                </Link>
              </p>

              <div className="hidden">
                <p className=" mb-4 text-center text-[#143A62] text-lg Campton-light font-normal">
                  or sign in with
                </p>
                <div className="social_links flex justify-center gap-8 md:gap-16">
                  <img
                    src={google}
                    alt=""
                    className=" cursor-pointer w-[60px] h-[40px] lg:w-[65px] xl:w-[75px] 2xl:w-auto lg-w-[50px] xl:h-[55px] 2xl:h-auto"
                  />
                  <img
                    src={facebook}
                    alt=""
                    className=" cursor-pointer w-[60px] h-[40px] lg:w-[65px] xl:w-[75px] 2xl:w-auto lg-w-[50px] xl:h-[55px] 2xl:h-auto"
                  />
                  <img
                    src={twitter}
                    alt=""
                    className=" cursor-pointer w-[60px] h-[40px] lg:w-[65px] xl:w-[75px] 2xl:w-auto lg-w-[50px] xl:h-[55px] 2xl:h-auto"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      {openModal && (
        <UserVerifyEmail
          openModal={openModal}
          setOpenModal={setOpenModal}
          openRecoveryModal={openRecoveryModal}
          setOpenRecoveryModal={setOpenRecoveryModal}
          openResetPasswordModal={openResetPasswordModal}
          setOpenResetPasswordModal={setOpenResetPasswordModal}
        />
      )}
    </div>
  );
}

export default UserSignIn;
